import EntitySync from "./EntitySync";
import StandsApi from "../../api/references/stands";
import SalePointMonitoringDocsApi from "../../api/SalePointMonitoringDocs";
import * as constants from "../../assets/constants";
import {CODE_SALE_POINT_MONITORING_STATUS_DRAFT, CODE_SALE_POINT_MONITORING_STATUS_NEW} from "../../assets/constants";
import moment from "moment";


class SalePointMonitoringDocsSync extends EntitySync {
    constructor(props) {
        super(props, 'sale_point_monitoring_docs', ['guid', 'id'])
    }


    async add(item) {

        const document_ = {
            date: new Date(),
            guid: item.doc_data.guid ?? null,
            images: item.doc_data.images,
            comment: item.docComment,
            klient_id: item.doc_data.klient ? item.doc_data.klient.uid : null,
            sale_point_id: item.doc_data.sale_point ? item.doc_data.sale_point.uid : null,
            useMall: item.doc_data.useMall ?? 0,
            mall_id: item.doc_data.mall ? item.doc_data.mall.uid : null,
            status: !item.doc_data.status || item.doc_data.status == CODE_SALE_POINT_MONITORING_STATUS_DRAFT ? CODE_SALE_POINT_MONITORING_STATUS_NEW : item.doc_data.status,
            items: item.items ? item.items.filter(el => el !== null) : []
        }

        if (item.questionnaire) {
            document_.questionnaire = item.questionnaire
        }

        if (item.doc_data && item.doc_data.id > 0) {
            document_['doc_id'] = item.doc_data.id
        }

        // Если документ уже имеет GUID, используем replaceByGUID для обновления
        if (document_.guid) {
            return await super.replaceByGUID(document_)
        }

        // Иначе создаем новую запись
        return await super.add(document_)
    }

    async getList(params) {
        try {

            const {search = '', epp, page} = params

            const checkSearch = el => {
                let check = true


                if (el.uploaded === true) check = false

                if (search.trim().length > 0 && check && el.doc_data) {
                    if (!el.doc_data.id.toLowerCase().includes(search.trim().toLowerCase())) check = false
                }
                return check
            }


            const total = await this.db[this.entityName]
                .filter(el => checkSearch(el)
                ).count()


            const results_ = await this.db[this.entityName].orderBy('createdAt')
                .filter(el => checkSearch(el))

                .offset((page - 1) * epp)
                .limit(epp)
                .toArray()

            const results = []

            results_.map(el => {

                const doc = {
                    ...el.value,
                    ...el
                }
                delete doc.value
                doc.time = moment(doc.date).format('HH:mm')
                doc.date = moment(doc.date).format('DD.MM.YYYY')
                doc.isOffline = true
                doc.items_cnt = doc.items ? doc.items.length : 0
                results.push(doc)
            })

            const iTotalPages = Math.ceil(total / epp)

            return {
                data: {
                    results,
                    total,
                    iTotalPages,
                    iTotalRecords: total,
                    iTotalDisplayRecords: results.length
                }
            }
        } catch (error) {
            console.error('Ошибка при получении списка с поиском и пагинацией:', error)
            return {
                data: {
                    results: [],
                    total: 0,
                    iTotalPages: 0
                }
            }
        }
    }

    async uploadEntity(document_) {
        const saved = localStorage.getItem('scladro_offline_mode');
        const isOffline =  saved ? JSON.parse(saved) : false;
        if(isOffline){
            return
        }

        try {
            const result = await SalePointMonitoringDocsApi.save(document_.value)
            window.postMessage('uploadedSalePointMonitoringDoc')
            return {success: result.data.success, result}
        } catch (error) {
            console.error('Ошибка при загрузке документа:', error)
        }
    }

}

export default SalePointMonitoringDocsSync